import { fetcher } from '@chipinside/fetcher'
import { fmt, Moment } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { Button, Typography } from '@mui/material'
import React from 'react'

import { Icon } from '#/components/Icon'
import { useFarmSlug } from '#/store/ducks/farm'
import { endpoint } from '#/store/services/endpoints'

export default function ViewAll({ timestamp, refresh, filters = [], enabled, style }) {
  const farmSlug = useFarmSlug()

  const handleMarkAllAsRead = () => {
    fetcher({
      params: {
        filters,
        timestamp: Moment(timestamp).format(fmt.api),
      },
      controller: endpoint.farm.alert.view_all({ farm: farmSlug }),
      method: 'put',
    }).then(() => refresh())
  }

  return enabled ? (
    <Button
      style={style}
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={<Icon size="large" name="drafts-outlined" />}
      onClick={handleMarkAllAsRead}
    >
      <Typography>{Translate({ messageKey: 'check_all_as_read' })}</Typography>
    </Button>
  ) : null
}
